import ButtonLove from "components/Button/ButtonLove"
import Price from "components/Price/Price"
import "components/Product/ProductCard.scss"
import _ from "lodash"
import { observer } from "mobx-react"
import PropTypes from "prop-types"
import React, { Component } from "react"
import Responsive from "react-responsive"
import { Link } from "react-router-dom"
import { Button, Card, Dropdown, Icon, Input, Label } from "semantic-ui-react"
import shop from "shop/shop"


@observer
class ProductCard extends Component {

 
  render() {
    let { product, categoryId = "" } = this.props
    const inCart = shop.cart.productsById.get( product.map_id )
    const useQuickorder = shop.config.plugin.orderFromTile && shop.session


  


    if ( !product ) return <div>LOADING</div>

    return (
      <Card
        className="product ProductCard hide-child">

        <div className="wrapper relative">

          {/* CARD B: NOT HOVER */}
          {/*<pre className="absolute top-0 left-0 right-0 f6 bg-black white">{JSON.stringify( {sort: product.sort}, null, 2 )}</pre>*/}
          <Link className="product-inner"
                to={`/product/${product.map_id}/?category=${categoryId}`}>
            <div className="pt5 image flex items-center justify-center">
              <img src={product.img_src_medium}
                   alt="..."
                   title=""
                   className="img-responsive"/>
            </div>
            <div className="caption pt5">
              <div className="f6" title={product.title}>{product.title}</div>
              <div className="category black-50 f6" title={product.category.title}>
                #{product.map_id}<br/><br/>{product.extraValue.specs}
              </div>

              {(inCart && inCart.count > 0) && <div className="absolute top-1 left-1 f6 black-40 ">
                <Icon name={"shopping cart"}/> {inCart.count * inCart.unit_multi} Stück
              </div>}

              <div className="actions">
                {(this.props.list) ? <ButtonLove list={this.props.list}
                                                 product={product}><Icon
                  name={"heart"}/></ButtonLove> : null} </div>

            </div>
          </Link>

          <div className="absolute top-1 left-1">
            <ButtonLove list={shop.orderlist.default}
                        className="dib mr3"
                        elementInActive={<span><Icon name={"heart outline"}/></span>}
                        elementActive={<span><Icon name={"heart"}/></span>}
                        product={product}/>
          </div>


          {this.props.children}

          <div className="badges absolute right-1 top-1 black-50 tr">
            {product.isSale && <div className="pb2"></div>}
            <div
              className="availability">{product.getNotice( "tiny", Number( product.extras.varbestand ) )}</div>
          </div>

          {product.price !== undefined ? <div>
            <div className="absolute right-1 bottom-1">

              <Button primary className="" icon={"cart"} onClick={() => {
                if ( product.count ) {
                  product.count += 1
                } else {
                  product.count = 1
                }
                shop.cart.add( product )
                shop.toast( `${product.count}x ${product.title} im Warenkorb`, "info", false, "bottom" )
              }}/>
            </div>
            {product.isSale &&
            <div className="price absolute bottom-1 left-1 color" title={translate( "Stückpreis" )}>
              {/*<span className="unit_multi black-70 f6 pb2 fw2">Stückpreis</span><br/>*/}
              <span className="f5 black-60 strike"><Price>{product.originalPrice}</Price></span> <br/>
              <span className="f5 red b"><Price>{product.pinfos.brutto}</Price></span>
            </div>}
            {!product.isSale &&
            <div className="price absolute bottom-1 left-1 color">
              <span className="unit_multi black-70 f6 pb2 fw2"> </span><br/>
              <span className="f5  b"><Price>{product.price}</Price></span>
            </div>}
          </div> : <div className="absolute right-1 bottom-1 left-1">
            <Link to={`/login/?referrer=/product/${product.map_id}`}> <Button fluid basic>Preise
              anzeigen </Button></Link>
          </div>
          }
        </div>

      </Card>
    )
  }
}

@observer
class CardOrder extends Component {
  
  state = {
    count: 0,
    quantity: this.props.product.quantities[ 0 ],
    isAdded: false,
    loading: false,
  }
  
  setQuantity( quantity ) {
    this.setState( { quantity }, this.toCart )
  }
  
  setCount( count ) {
    count = Math.max( 0, count )
    this.setState( { count }, this.toCart )
  }
  
  toCart = () => {
    let { quantity, count, isAdded } = this.state
    let { product } = this.props
    if ( count > 0 ) {
      product.count = count
      product.unit_id = quantity.map_desc_id
      product.unit_multi = quantity.multi
      shop.cart.add( product )
      shop.toast( `${product.count}x${product.unit_multi} Stk. ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom" )
      this.setState( { product, isAdded: true } )
      this.props.onChange && this.props.onChange( { product } )
    } else {
      shop.cart.remove( product )
    }
  }
  
  render() {
    let { quantity, count, isAdded } = this.state
    let { product } = this.props
    const inCart = shop.cart.productsById.get( product.map_id )
    
    if ( !product.canBeBought ) return <div>{translate( "Nicht verfügbar" )}</div>
    return <div className={`CardOrder pt3 ${inCart ? "inCart" : ""}`}>
      
      <div className="labels ">
      </div>
      
      
      <div className="pb3 tc f5-ns f7">
        <Responsive minWidth={"560px"}>
          {product.quantities.length > 3 ?
            <Dropdown
              selection
              fluid
              value={quantity}
              onChange={( e, data ) => {
                this.setQuantity( data.value )
              }}
              options={product.quantities.map( q => {
                return {
                  key: q.multi,
                  text: `${q.des} (${q.multi})`,
                  value: q
                }
              } )}
            />
            :
            <Button.Group className="quantities" basic size="tiny">
              {product.quantities.map( q => {
                return <Button
                  active={quantity.map_desc_id === q.map_desc_id}
                  key={q.map_desc_id}
                  onClick={() => {
                    this.setQuantity( q )
                    // this.setState( { quantity: q } )
                  }
                  }>{`${q.des} (${q.multi})`}</Button>
              } )}
            </Button.Group>
          }
        
        </Responsive>
        
        <Responsive maxWidth={"559px"}>
          <Dropdown
            selection
            fluid
            value={quantity}
            onChange={( e, data ) => {
              // this.setState( { quantity: data.value } )
              this.setQuantity( data.value )
            }}
            options={product.quantities.map( q => {
              return {
                key: q.multi,
                text: `${q.des} (${q.multi})`,
                value: q
              }
            } )}
          />
        </Responsive>
      
      
      </div>
      
      <div className="flex flex-auto w-100  QuickorderTab" style={{ justifyContent: "space-between" }}>
        <Button circular basic floated="right" icon="minus" onClick={() => {
          if ( product.count > 0 ) {
            count -= 1
          } else {
            count = 0
          }
          this.setCount( count )
        }
        }/>
        
        <div className="quickorder-input ">
          <Input type="number" value={count} onChange={e => {
            let count = Math.max( 0, Number( e.target.value ) )
            this.setCount( count )
          }}/>
        </div>
        
        <Button circular basic floated="right" icon="plus" onClick={() => {
          if ( count ) {
            count += 1
          } else {
            count = 1
          }
          
          this.setCount( count )
        }
        }/>
      </div>
      
      {/*<div className="tc">*/}
      {/*  <Button*/}
      {/*    color={isAdded ? "green" : "blue"}*/}
      {/*    circular fluid*/}
      {/*    onClick={() => {*/}
      {/*      console.log( "adding", { state: this.state } )*/}
      {/*      this.toCart()*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    {isAdded && <div className={"animate fadeInUp"}>Hinzugefügt</div>}*/}
      {/*    {!isAdded && <span> In den Warenkorb</span>}*/}
      {/*  </Button>*/}
      {/*</div>*/}
    </div>
  }
}

CardOrder.propTypes = { product: PropTypes.any }


ProductCard.defaultProps = {
  quickorder: false
}

ProductCard.propTypes = {
  quickorder: PropTypes.any,
  list      : PropTypes.object,
  product   : PropTypes.object,
  xs        : PropTypes.string,
  sm        : PropTypes.string,
  md        : PropTypes.string,
  lg        : PropTypes.string,
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/theme/hobbyfun/components/Product/ProductCard.js